import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";

import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";
import getColor from "@insite/mobius/utilities/getColor";

type Props = ReturnType<typeof mapStateToProps> & WidgetProps;

export interface ProductDetailsViewStyles {
    container?: GridContainerProps;
    productDescInfoContainerColumnGridItem?: GridItemProps;
    productDescHeadContainerColumnGridItem?: GridItemProps;
}

const mapStateToProps = (state: ApplicationState) => ({
    isAuthenticated: getSession(state).isAuthenticated,
});

export const viewStyles: ProductDetailsViewStyles = {
    container: {
        css: css`
            [data-test-selector="packDescriptionText"]{
                color: ${getColor("primary.contrast")} !important;
            }
            [data-test-selector="priceIncludeVat"]{
                span{
                    font-size: 26px !important; 
                    font-weight: bold !important;
                }
            }
            [data-test-selector="productDetails_productDescInfoContainerItem"] {
                background-color: #254351;
                padding: 30px 20px;
                color: #fff;
                [data-test-selector="productPrice_unitNetPrice"],
                [data-test-selector="productPrice_unitOfMeasureLabel"] {
                    color: #fff;
                }
                    [data-test-selector="availabilityMessage"] {
                        color: ${getColor("primary.contrast")};
                        font-weight: 800;
                        font-family: 'Franklin Gothic Demi';
                        font-size: 14px;
                        margin-top: 5px;
                        margin-bottom: 8px;
                    }
            }   
            [data-test-selector="productDetails_productDescHeadContainerItem"] {
                padding: 0px;
            }   
            [data-test-selector="availabilityByWarehouseLink"]{
                span{
                    color: ${getColor("primary.contrast")} !important;
                    text-decoration: underline;
                }
            }
        `,
    },

    productDescInfoContainerColumnGridItem: {
        width: [12, 12, 12, 12, 12],
        css: css`

        `
    },
    productDescHeadContainerColumnGridItem: {
        width: [12, 12, 12, 12, 12],
        css: css`
            [data-test-selector="productDetails_shareLinkWrapper"] {
                text-align: right;
            }
            [data-test-selector="productDetails_shareLinkWrapper"] button{
                color: #02788c;
                border: 3px solid #02788c;
                background-color: #fff;
                padding: 10px;
                height: auto;
                font-size: 20px;
                text-transform: uppercase;
                text-align: center;
                text-decoration: none !important;
                span{
                    color: #02788c !important;
                }
            }
        `
    },
};

const styles = viewStyles;

const ProductDetailsInfoContainer: React.FC<Props> = ({ id, isAuthenticated }) => {
    return (
        <GridContainer {...styles.container}>
            {isAuthenticated ?
                <GridItem {...styles.productDescInfoContainerColumnGridItem} data-test-selector="productDetails_productDescInfoContainerItem">
                    <Zone contentId={id} zoneName="Content0"/>
                </GridItem> :
                <GridItem {...styles.productDescHeadContainerColumnGridItem} data-test-selector="productDetails_productDescHeadContainerItem">
                    <Zone contentId={id} zoneName="Content1"/>
                </GridItem>
            }
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ProductDetailsInfoContainer),
    definition: {
        displayName: "Product Info Container",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
